import {Component, Host, h, Prop, EventEmitter, Event} from '@stencil/core';
import {Logger} from "../../utils/logger";
import {IRequestField} from "../../interfaces/configuration";

@Component({
  tag: 'securecall-request-secure',
  styleUrl: 'securecall-request-secure.css',
  shadow: true,
})
export class SecurecallRequestSecure {
  @Prop() fieldName: string;
  @Prop() config: IRequestField;

  @Event() secureFieldResetEvent: EventEmitter<string>;

  private readonly log = Logger('SecurecallRequestSecure')

  handleClick(ev) {
    ev.preventDefault();
    this.log.debug("handleClick: field", this.fieldName, "clicked");
    this.config.valid = false;
    this.secureFieldResetEvent.emit(this.fieldName)
  }

  render() {
    return (
      <Host>
        <div class="field-container">
          <label class="custom-label" htmlFor={this.fieldName}>
            {this.config["label"]}: {this.config.active}
          </label>
          <input
            type="text"
            class={`custom-input ${this.config.active ? 'active' : 'inactive'}`}
            id={this.fieldName}
            readOnly
            placeholder={this.config.value}>
          </input>
          <div class={{validity: true, valid: this.config.valid}} onClick={(ev) => this.handleClick(ev)}></div>
        </div>
      </Host>
    );
  }

}
